import { Separator } from '@givebutter/primitives/separator';
import * as ItemOptions from 'components/pages/campaign-settings/campaign-auction/ItemOptions';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { AuctionItem } from 'types/domain';

interface ItemOptionsDropdownProps {
    item: AuctionItem;
    onDelete?: () => void;
}

const ItemOptionsDropdown = (props: ItemOptionsDropdownProps) => {
    const { item, onDelete } = props;
    const { data: campaign } = useCurrentCampaign();
    const { auctionsItemWinner = false } = useFlags();

    return (
        <ItemOptions.Root item={item} campaign={campaign}>
            <ItemOptions.Trigger />
            <ItemOptions.Content align={'end'}>
                <div className="flex flex-col gap-1">
                    <div className="flex flex-col">
                        <ItemOptions.Edit />
                        <ItemOptions.ViewDetails />
                        <ItemOptions.ExportQRCode />
                        <ItemOptions.ViewItem />
                    </div>
                    <Separator />
                    <div className="flex flex-col">
                        <ItemOptions.Duplicate />
                        <ItemOptions.ToggleHideListing />
                        <ItemOptions.TogglePublish />
                    </div>
                    <Separator />
                    <div className="flex flex-col">
                        <ItemOptions.EndListing />
                        <ItemOptions.CancelListing />
                        <ItemOptions.PauseBidding />
                        {auctionsItemWinner && <ItemOptions.DeclareWinner />}
                        <ItemOptions.Extend />
                        <ItemOptions.ResumeBidding />
                    </div>
                    <Separator />
                    <ItemOptions.Delete onDelete={onDelete} />
                </div>
            </ItemOptions.Content>
        </ItemOptions.Root>
    );
};

export { ItemOptionsDropdown };
